import React from 'react';
import { ArrowRight, Globe, Shield, Sparkles } from 'lucide-react';

const AboutPage = ({ onGetStarted }) => (
  <div>
    <section className="py-20 px-6">
      <div className="max-w-3xl mx-auto">
        <span className="font-label text-[var(--color-coral)] mb-3 inline-block">ABOUT STILOS</span>
        <h1 className="font-serif text-4xl md:text-5xl mb-6">We're building the content<br />engine for the AI era</h1>
        <p className="text-base text-[var(--color-muted)] leading-relaxed mb-8">
          Stilos was born from a simple observation: the businesses with the most authoritative content will be the ones AI cites as trusted sources. And right now, small businesses are being left behind.
        </p>
        <p className="text-sm text-[var(--color-muted)] leading-relaxed mb-8">
          We're a product of <strong className="text-[var(--color-charcoal)]">Themelio</strong> — a holding company building tools that help ambitious businesses compete with enterprises. Stilos is the first product in our ecosystem, focused on making AI-ready content creation accessible to everyone.
        </p>
      </div>
    </section>

    <section className="py-20 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="font-serif text-2xl text-center mb-12">Our principles</h2>
        <div className="grid md:grid-cols-3 gap-6">
          {[
            { icon: Sparkles, title: 'AI Assists, Never Replaces', desc: 'Your voice is the foundation. We amplify it with AI structure and optimization — the ideas and authority are always yours.' },
            { icon: Shield, title: 'Privacy Is Non-Negotiable', desc: 'Your content is never used to train AI models. GDPR-compliant. Encrypted. Your data belongs to you — period.' },
            { icon: Globe, title: 'Built for the Ambitious Few', desc: "We don't build for everyone. We build for small businesses and lean teams that punch above their weight with quality content." },
          ].map((p, i) => (
            <div key={i} className="card p-7 text-center">
              <div className="w-10 h-10 mx-auto rounded-full flex items-center justify-center mb-4 bg-[var(--color-surface)]">
                <p.icon className="w-5 h-5 text-[var(--color-coral)]" />
              </div>
              <h3 className="font-display text-sm font-medium mb-2">{p.title}</h3>
              <p className="text-xs text-[var(--color-muted)] leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="py-20 px-6">
      <div className="max-w-3xl mx-auto">
        <h2 className="font-serif text-2xl mb-6">The Themelio ecosystem</h2>
        <p className="text-sm text-[var(--color-muted)] leading-relaxed mb-8">
          Themelio is building a suite of tools for ambitious small businesses. Stilos is the content engine. More products are on the way — each designed to solve a specific pain point in the SMB growth journey.
        </p>
        <div className="card p-6 mb-6">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-8 h-8 rounded-lg flex items-center justify-center text-white font-bold text-xs" style={{background: 'linear-gradient(135deg, #E8735C, #C9A962)'}}>S</div>
            <div>
              <p className="font-display text-sm font-medium">Stilos</p>
              <p className="text-[10px] text-[var(--color-coral)]">Live</p>
            </div>
          </div>
          <p className="text-xs text-[var(--color-muted)]">AI-powered content creation with voice-first workflow, AEO/GEO optimization, and brand reporting.</p>
        </div>
        <div className="card p-6 opacity-50">
          <p className="font-display text-sm font-medium mb-1">More coming soon</p>
          <p className="text-xs text-[var(--color-muted)]">Vasis, Edrano, and more tools designed for the SMB growth stack.</p>
        </div>
      </div>
    </section>

    <section className="py-20 px-6 bg-white">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="font-serif text-3xl mb-4">Join the beta</h2>
        <p className="text-[var(--color-muted)] text-sm mb-8">Be among the first to build content pillars that AI trusts.</p>
        <button onClick={onGetStarted} className="btn btn-primary text-base px-8 py-3">
          Start free <ArrowRight className="w-5 h-5" />
        </button>
      </div>
    </section>
  </div>
);

export default AboutPage;
